import CommitModelsForm from "./CommitModelsForm";
import GithubConfigForm from "./GithubConfigForm";
import QuerySelectionForm from "./QuerySelectionForm";

interface Props {
  interruptAction: string | null;
}

const DBTInterrupt = ({ interruptAction }: Props) => {
  if (!interruptAction) return null;

  switch (interruptAction) {
    case "DBT-github_credentials":
      return <GithubConfigForm />;

    case "DBT-query_selection":
      return <QuerySelectionForm />;

    case "DBT-commit_models":
      return <CommitModelsForm />;

    default:
      return null;
  }
};

export default DBTInterrupt;
